var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayPal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.445,
    height: 23.8,
    viewBox: "0 0 97.445 23.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment_Option_3",
    "data-name": "Payment Option 3",
    transform: "translate(893 -11625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "M136.222,29.156c-.287,1.943-1.766,1.943-3.2,1.943H132.2l.574-3.621a.449.449,0,0,1,.442-.375h.375c.971,0,1.9,0,2.362.552A1.767,1.767,0,0,1,136.222,29.156ZM135.6,24.1h-5.387a.759.759,0,0,0-.751.64L127.28,38.561a.447.447,0,0,0,.442.508H130.3a.759.759,0,0,0,.751-.64l.6-3.731a.753.753,0,0,1,.729-.64h1.7c3.555,0,5.608-1.722,6.138-5.122a4.237,4.237,0,0,0-.684-3.488A5.174,5.174,0,0,0,135.6,24.1Z",
    transform: "translate(-992.166 11606.221)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M191.358,50.855a2.871,2.871,0,0,1-2.914,2.473,2.2,2.2,0,0,1-1.744-.706,2.168,2.168,0,0,1-.4-1.81,2.9,2.9,0,0,1,2.892-2.495,2.181,2.181,0,0,1,1.722.706A2.271,2.271,0,0,1,191.358,50.855Zm3.6-5.012h-2.583a.433.433,0,0,0-.442.375l-.11.729-.177-.265c-.552-.817-1.81-1.082-3.047-1.082a5.933,5.933,0,0,0-5.762,5.188,4.914,4.914,0,0,0,.971,3.974,4.048,4.048,0,0,0,3.245,1.3,4.957,4.957,0,0,0,3.577-1.479l-.11.706a.466.466,0,0,0,.442.53h2.318a.759.759,0,0,0,.751-.64l1.391-8.831A.477.477,0,0,0,194.956,45.843Z",
    transform: "translate(-1035.401 11589.468)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M257.787,46.7H255.2a.764.764,0,0,0-.618.331l-3.577,5.255-1.523-5.056a.762.762,0,0,0-.729-.53h-2.539a.444.444,0,0,0-.419.6l2.848,8.39-2.694,3.8a.444.444,0,0,0,.375.706h2.583a.711.711,0,0,0,.618-.331l8.632-12.452A.449.449,0,0,0,257.787,46.7Z",
    transform: "translate(-1084.499 11588.61)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M310.4,29.156c-.287,1.943-1.766,1.943-3.2,1.943h-.817l.574-3.621a.449.449,0,0,1,.442-.375h.375c.971,0,1.9,0,2.362.552A1.767,1.767,0,0,1,310.4,29.156Zm-.618-5.056h-5.387a.72.72,0,0,0-.729.64L301.48,38.561a.447.447,0,0,0,.442.508h2.76a.487.487,0,0,0,.508-.442l.618-3.908a.753.753,0,0,1,.729-.64h1.7c3.555,0,5.608-1.722,6.138-5.122a4.237,4.237,0,0,0-.684-3.488A4.945,4.945,0,0,0,309.781,24.1Z",
    transform: "translate(-1127.906 11606.221)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M365.458,50.855a2.871,2.871,0,0,1-2.914,2.473,2.2,2.2,0,0,1-1.744-.706,2.168,2.168,0,0,1-.4-1.81,2.9,2.9,0,0,1,2.892-2.473,2.052,2.052,0,0,1,2.164,2.517Zm3.6-5.012h-2.583a.433.433,0,0,0-.442.375l-.11.729-.177-.265c-.552-.817-1.81-1.082-3.047-1.082a5.933,5.933,0,0,0-5.762,5.188,4.914,4.914,0,0,0,.971,3.974,4.048,4.048,0,0,0,3.245,1.3,4.957,4.957,0,0,0,3.577-1.479l-.11.706a.466.466,0,0,0,.442.53h2.318a.72.72,0,0,0,.729-.64l1.391-8.831A.436.436,0,0,0,369.056,45.843Z",
    transform: "translate(-1171.064 11589.468)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M418.088,24.4,415.88,38.483a.447.447,0,0,0,.442.508h2.23a.759.759,0,0,0,.751-.64l2.186-13.821a.466.466,0,0,0-.442-.53h-2.495A.476.476,0,0,0,418.088,24.4Z",
    transform: "translate(-1217.048 11606.299)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M35.451,27.4c-.022.132-.044.287-.066.442-.994,4.99-4.327,6.712-8.588,6.712H24.632a1.046,1.046,0,0,0-1.038.883l-1.1,7.043-.309,1.987a.557.557,0,0,0,.552.64h3.82a.906.906,0,0,0,.905-.773l.044-.2.729-4.592.044-.243a.923.923,0,0,1,.905-.773h.574c3.731,0,6.645-1.523,7.507-5.895.353-1.832.177-3.356-.773-4.438A3.5,3.5,0,0,0,35.451,27.4Z",
    transform: "translate(-910.271 11603.649)",
    fill: "#bce0fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M39.44,24.331a3.529,3.529,0,0,0-.464-.11,3.744,3.744,0,0,0-.486-.088A12.909,12.909,0,0,0,36.57,24H30.786a.808.808,0,0,0-.4.088.91.91,0,0,0-.508.684l-1.236,7.816-.044.221a1.063,1.063,0,0,1,1.038-.883H31.8c4.261,0,7.595-1.722,8.566-6.734.022-.155.044-.287.066-.442a4.289,4.289,0,0,0-.795-.331A.784.784,0,0,0,39.44,24.331Z",
    transform: "translate(-915.277 11606.299)",
    fill: "#7fc4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M7.541,6.071a.91.91,0,0,1,.508-.684.866.866,0,0,1,.4-.088h5.784a13.125,13.125,0,0,1,1.921.132c.177.022.331.066.486.088.155.044.309.066.464.11.066.022.155.044.221.066a4.289,4.289,0,0,1,.795.331,4.716,4.716,0,0,0-.994-4.239C16.019.53,14.032,0,11.493,0H4.1A1.029,1.029,0,0,0,3.059.883L-.032,20.422a.634.634,0,0,0,.618.729h4.57L6.3,13.887Z",
    transform: "translate(-892.959 11625)",
    fill: "#2699fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPal);
export default __webpack_public_path__ + "static/media/payPal.1cd476d9bc801981658eb944f456b56d.svg";
export { ForwardRef as ReactComponent };